<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-1']" width="128px" v-model="animation" :items="animations" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="12" v-for="item in 4" :key="item" sm24>
        <card>
          <card-text>
            <table-layout y-align="middle">
              <row>
                <cell style="width: 96px" :class="['p-1']">
                  <skeleton-loader :animation="animation[0]" type="circle" width="96px" :bg-color-lightness="$dark ? 900 : 300" />
                </cell>
                <cell :class="['p-1']">
                  <skeleton-loader :animation="animation[0]" type="rectangle" :bg-color-lightness="$dark ? 900 : 300" height="16px" rounded="full" />
                  <skeleton-loader :animation="animation[0]" type="rectangle" :bg-color-lightness="$dark ? 900 : 300" height="16px" width="80%" rounded="full" :class="['my-2']" />
                  <skeleton-loader :animation="animation[0]" type="rectangle" :bg-color-lightness="$dark ? 900 : 300" height="16px" width="85%" rounded="full" />
                </cell>
              </row>
            </table-layout>
          </card-text>
          <divider />
          <card-actions>
            <skeleton-loader :animation="animation[0]" type="rectangle" :block="false" :bg-color-lightness="$dark ? 900 : 300" height="28px" width="128px" rounded="sm" /><!--
            --><skeleton-loader :animation="animation[0]" type="rectangle" :block="false" :bg-color-lightness="$dark ? 900 : 300" height="28px" width="128px" rounded="sm" :class="['ml-2']" />
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSkeletonLoader',
  mixins: [
    methods
  ],
  data () {
    return {
      animation: ['fade'],
      animations: ['none', 'fade', 'pulse', 'pulse-x', 'pulse-y', 'wave'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/skeleton-loader.vue